import { BotRecommendationRequest } from '@/models/BotRecommendationRequest';
import Category from '@/models/Category';
import { DialogFlowMessage } from '@/models/Chat';
import Item from '@/models/Item';
import { BufferingMessages } from '@/pages/Chat/ChatModal/types';
import { ContentStudentView } from '../content/types';
import { LearningMap } from '../learningMap/types';

export interface UserMessage {
    message: string;
}

export interface ChipMessage {
    message: string;
}

export interface AnswerMessage {
    answer: any;
}

export type AnsweredMessage = DialogFlowMessage & AnswerMessage;

export type ChatMessageTypes = UserMessage | ChipMessage;

export interface ReplyMessage {
    isAnswer: boolean;
}

export type ChatMessage = ChatMessageTypes & ReplyMessage;

export enum ChatActionTypes {
    COMPLETE_SEND_CHAT_MESSAGE_REQUEST = '@chat/COMPLETE_SEND_CHAT_MESSAGE_REQUEST',
    COMPLETE_CHAT_SUCCESS = '@chat/COMPLETE_CHAT_SUCCESS',
    COMPLETE_CHAT_FAILURE = '@chat/COMPLETE_CHAT_FAILURE',
    BUFFERING = '@chat/BUFFERING',
    MARK_CHIP_ANSWER = '@chat/MARK_CHIP_ANSWER',
    BUILDING_LEARNING_MAP = '@chat/BUILDING_LEARNING_MAP',
    BUILDING_CONTENT_RECOMMENDATIONS = '@chat/BUILDING_CONTENT_RECOMMENDATIONS',
    BUILDING_CONTENT_RECOMMENDATIONS_CLEAR = '@chat/BUILDING_CONTENT_RECOMMENDATIONS_CLEAR',
    SEND_NEW_EVENT_REQUEST = '@chat/SEND_NEW_EVENT_REQUEST',
    SEND_NEW_EVENT_SUCCESS = '@chat/SEND_NEW_EVENT_SUCCESS',
    SEND_NEW_EVENT_FAILURE = '@chat/SEND_NEW_EVENT_FAILURE',
    GET_CATEGORIES_REQUEST = '@chat/GET_CATEGORIES_REQUEST',
    GET_CATEGORIES_SUCCESS = '@chat/GET_CATEGORIES_SUCCESS',
    GET_CATEGORIES_FAILURE = '@chat/GET_CATEGORIES_FAILURE',
    GET_CATEGORIES_CLEAR = '@chat/GET_CATEGORIES_CLEAR',
    GET_RECOMMENDATION_REQUEST = '@chat/GET_RECOMMENDATION_REQUEST',
    GET_RECOMMENDATION_FAILURE = '@chat/GET_RECOMMENDATION_FAILURE',
    SET_CURRENT_CONTENT_STUDENT_VIEW = '@chat/SET_CURRENT_CONTENT_STUDENT_VIEW',
    SELECT_RECOMMENDATION_CONTENT_REQUEST = '@chat/SELECT_RECOMMENDATION_CONTENT_REQUEST',
    SELECT_RECOMMENDATION_CONTENT_SUCCESS = '@chat/SELECT_RECOMMENDATION_CONTENT_SUCCESS',
    SELECT_RECOMMENDATION_CONTENT_FAILURE = '@chat/SELECT_RECOMMENDATION_CONTENT_FAILURE',
    OPEN_CHAT_MODAL = '@chat/OPEN_CHAT_MODAL',
    CLOSE_CHAT_MODAL = '@chat/CLOSE_CHAT_MODAL',
    SEND_NEW_MESSAGE_REQUEST = '@chat/SEND_NEW_MESSAGE_REQUEST',
    SEND_NEW_MESSAGE_SUCCESS = '@chat/SEND_NEW_MESSAGE_SUCCESS',
    SET_UNREAD_MESSAGES = '@chat/SET_UNREAD_MESSAGES',
    SET_BOT_ACTION = '@chat/SET_BOT_ACTION',
    DISMISS_BOT_ACTION = '@chat/DISMISS_BOT_ACTION',
}

export interface ListContentStudentViewData {
    contentStudentViewList: ContentStudentView[];
    total: number;
}
export interface BotRecommendationResult {
    listContentStudentViewResult: ListContentStudentViewData;
    botRecommendationId: number;
}

export interface ChatState {
    data: {
        eventMessages: DialogFlowMessage[];
        messages: DialogFlowMessage[];
        buffering: BufferingMessages;
    };
    buildingLearningMap: LearningMap;
    buildingContentRecommendations: BotRecommendationRequest;
    categoriesList: Category[];
    loading: boolean;
    hasError: boolean;
    openedChat: boolean;
    hasUnreadMessages: boolean;
    action: BotAction | null;
}
export interface ChatbotOutput {
    chatbotMessagesData: DialogFlowMessage[];
}

export interface BotAction {
    type: string;
    message: string;
    rating: number;
    content: Item;
}
